import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import OrderSummary from './OrderSummary.js';
import PrimaryBlueButton from '../components/common/buttons/PrimaryBlueButton.js';
import { Box } from '@mui/material';
import { colors } from '../styles/fontStyles';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

export default function CheckoutPaymentMethod({
  address,
  order,
  product,
  productPrice,
  quantity,
  sCheckoutURL,
  subjects,
  contact,
}) {
  const { theme } = useThemeContext();
  return (
    <Grid key={'grid-container-checkout'} container spacing={2}
      sx={{
        textAlign: 'left',
      }}
    >
      <OrderSummary
        address={address}
        order={order}
        product={product}
        productPrice={productPrice}
        quantity={quantity}
        sCheckoutURL={sCheckoutURL}
        subjects={subjects}
        contact={contact}
      />

      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'left',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <Box
          item
          xs={12}
          alignItems="center"
          sx={{ width: { xs: '100%', md: '33%' }, flexBasis: { xs: '100%', md: '33%' } }}
        >
          <PrimaryBlueButton
            sxProps={{ width: { xs: '100%', md: 'auto' } }}
            buttonText="Go to Payment"
            additionalProps={{ href: sCheckoutURL, target: '_blank' }}
          />
        </Box>

        <Box item xs={12} sx={{ marginTop: { xs: 2, md: '0' }, flexBasis: { xs: '100%', md: '65%' } }}>
          <Typography variant="body2" color={theme.custom.orderPFAS.checkout.redirectInstructionsColor}>
            You will be redirected to our payment.{' '}
          </Typography>
          <Typography variant="body2" color={theme.custom.orderPFAS.checkout.buttonInstructionsColor}>
            Please click the "Go to Payment" button if you are not redirected automatically.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}
